import {UPDATE_PERMISSIONS} from './types'

export const updatePermissions = data => ({ type: UPDATE_PERMISSIONS, payload: data })
